var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 9.96153C21 16.8948 12 22.8376 12 22.8376C12 22.8376 3 16.8948 3 9.96153C3 7.59735 3.94821 5.32999 5.63604 3.65826C7.32387 1.98653 9.61305 1.04736 12 1.04736C14.3869 1.04736 16.6761 1.98653 18.364 3.65826C20.0518 5.32999 21 7.59735 21 9.96153Z",
    stroke: "#0086FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.933C13.6569 12.933 15 11.6027 15 9.96162C15 8.32057 13.6569 6.99023 12 6.99023C10.3431 6.99023 9 8.32057 9 9.96162C9 11.6027 10.3431 12.933 12 12.933Z",
    stroke: "#0086FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.7711,
    fill: "rgba(38, 50, 56, 1)",
    transform: "translate(0 0.0571289)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.cafafa1def6ff1cd2b3ffbf9ea682b12.svg";
export { ForwardRef as ReactComponent };